import styled from 'styled-components';
import {
  DESKTOP_MIN_BREAK,
  MOBILE_MAX_BREAK,
  SIDE_PANEL_MIN_WIDTH,
  SIDE_PANEL_MAX_WIDTH,
  SIDE_PANEL_OFFSET,
  SIDE_PANEL_WIDTH,
  Z_INDEX_499,
  Z_INDEX_600,
  TOP_BORDER_RADIUS,
  SIDE_PANEL_DURATION,
} from '#/shared/constants';

export const TripToolsOuter = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const TripToolsInner = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  /* this must be set to relative positioning so that the overlay panel can
  be absolutely positioned against it */
  position: relative;

  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    overflow: hidden;
  }
`;

export const OverlayPanel = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;

  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
  }

  /* Any children of the overlay should be clickable */
  & > * {
    pointer-events: auto;
  }
`;

// this container is used to center the content (sidebar and map buttons)
// on desktop once the screen exceeds the max content width
export const ContentPanel = styled.div`
  display: flex;
  flex: 1 0 auto;
  margin-top: ${props => `${props.mapOffsetMobile}px`};

  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    position: absolute;
    top: 0;
    z-index: ${Z_INDEX_600};
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    pointer-events: none;
    margin-top: 0;
  }

  /* Any children of the overlay should be clickable */
  & > * {
    pointer-events: auto;
  }
`;

export const SidePanelWrapper = styled.div.attrs({ id: 'side-panel' })`
  display: ${props => (props.hideSidePanel ? 'none' : 'flex')};
  flex: 1;
  flex-direction: column;

  @media (max-width: ${MOBILE_MAX_BREAK}) {
    z-index: ${props => (props.isHome ? Z_INDEX_600 : Z_INDEX_499)};
    width: 100%;
  }

  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    max-width: ${SIDE_PANEL_MAX_WIDTH};
    min-width: ${SIDE_PANEL_MIN_WIDTH};
    left: ${SIDE_PANEL_OFFSET};
    width: ${SIDE_PANEL_WIDTH};
    position: absolute;
    box-shadow: ${({ isHome, minimized, theme }) =>
      isHome || minimized ? 'none' : theme.boxShadowPanel};
    border-radius: ${TOP_BORDER_RADIUS};
    bottom: ${({ bottom }) => bottom};
    transition: bottom ${SIDE_PANEL_DURATION} ease-out;
  }

  /* adjust styling for wrappers created by Reach Router; attribute selectors
  are used because there aren't many hooks on these divs, see further info here:
  https://github.com/gatsbyjs/gatsby/issues/7310#issuecomment-419977425

  ensure Reach Router divs in this tree take up all of the available space in
  their parent container and allow their children to flex vertically as well */
  & div[role='group'][tabindex] {
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
  }
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    & div[role='group'][tabindex] {
      overflow: hidden;
    }
  }
`;

export const SidePanel = styled.div`
  display: flex;
  flex: 1;
`;
